/* eslint-disable no-restricted-imports -- Only place needed to import flat-ui components */
import { Dropdown as FlatUiDropdown, DropdownProps } from "@faro-lotv/flat-ui";

/**
 * The flat-ui Dropdown, without capitalizing its text: flat-ui capitalizes by default, which
 * would change values such as the area units and environment names.
 */
export function Dropdown<Value extends string | number = string>(
  props: DropdownProps<Value>
): React.JSX.Element {
  return <FlatUiDropdown shouldCapitalize={false} {...props} />;
}
